export const fieldValidationDivision={code:null,name:null}